import { useEffect, useRef } from "react";
import { Faq } from "./components/Faq";
import { FinalCta } from "./components/FinalCta";
import { Footer } from "./components/Footer";
import { Grain } from "./components/Grain";
import { GridOverlay } from "./components/GridOverlay";
import { Hero } from "./components/Hero";
import { HowItWorks } from "./components/HowItWorks";
import { SubscriptionSection } from "./components/SubscriptionSection";
import { TimelineDebug } from "./components/TimelineDebug";
import { TimesAreChanging } from "./components/TimesAreChanging";
import type { CylinderCarouselHandle } from "./components/CylinderCarousel";
import { useScrollReveal } from "./hooks/useScrollReveal";
import { initLenis } from "./lib/lenis";

export function App() {
  useScrollReveal();
  useEffect(() => initLenis(), []);
  const carouselRef = useRef<CylinderCarouselHandle>(null);

  return (
    <>
      <a className="skip-link" href="#main">Skip to content</a>
      <Grain />
      <GridOverlay />
      <main id="main">
        <Hero />
        <TimesAreChanging carouselRef={carouselRef} />
        <SubscriptionSection carouselRef={carouselRef} />
        <HowItWorks />
        <Faq />
        <FinalCta />
      </main>
      <Footer />
      <div style={{ display: "none" }}>
        <TimelineDebug />
      </div>
    </>
  );
}
